import { css } from 'styled-components';
import {
    ColorNeutralWhite,
    ColorNeutralLightGrey,
    BorderWidthSmall,
    ColorBrandBlue1,
    ColorSystemNegative3
} from 'autogen/design-tokens/tokens';

export const ValidInputStyle = css`
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    border: ${({ theme }) => `1px solid ${theme.ColorBorderPrimary};`};

    &:hover {
        border-color: ${({ theme }) => theme.ColorBorderHover};
    }
`;

export const ValidInputFocusStyle = css`
    outline: none;
    border-color: ${ColorBrandBlue1};
`;

export const ValidInputDisabledStyle = css`
    background-color: ${({ theme }) => theme.ColorBackgroundDisabled};
    border: ${({ theme }) => `1px solid ${theme.ColorBorderDisabled};`};
    color: ${({ theme }) => theme.ColorTextDisabled};

    & > svg {
        fill: ${({ theme }) => theme.ColorIconDisabled};
    }

    &:hover {
        border-color: ${({ theme }) => theme.ColorBorderDisabled};
        cursor: not-allowed;
    }
`;

export const InvalidInputStyle = css`
    border: ${({ theme }) => `1px solid ${theme.ColorBorderError}`};
`;

export const InvalidInputFocusStyle = css`
    outline: none;
`;
